import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { getDetailLabel } from '@/shared/copy/details';

export type CoverageCodeFilesSortKey =
  | 'fileName'
  | 'normalizedPath'
  | 'linesPct'
  | 'functionsPct'
  | 'branchesPct'
  | 'statementsPct'
  | 'latestCapturedAt';

export const coverageCodeFilesTableDefinition: TableDefinition<CoverageCodeFilesSortKey, 'unused'> =
  createTableDefinition({
    title: 'Files',
    searchAriaLabel: 'Search files',
    columns: [
      { field: 'file', label: 'File', mandatory: true, defaultVisible: true },
      { field: 'lineCoverage', label: 'Line', defaultVisible: true },
      { field: 'functionCoverage', label: 'Function', defaultVisible: true },
      { field: 'branchCoverage', label: 'Branch', defaultVisible: true },
      { field: 'statementCoverage', label: 'Statement', defaultVisible: true },
      { field: 'details', label: getDetailLabel('details'), defaultVisible: true },
      { field: 'actions', label: getDetailLabel('actions'), defaultVisible: true },
    ],
    defaultSortKey: 'fileName',
    defaultSortDirection: 'asc',
    sortOptions: [
      { key: 'fileName', label: 'File' },
      { key: 'normalizedPath', label: 'Path' },
      { key: 'linesPct', label: 'Line' },
      { key: 'functionsPct', label: 'Function' },
      { key: 'branchesPct', label: 'Branch' },
      { key: 'statementsPct', label: 'Statement' },
      { key: 'latestCapturedAt', label: 'Latest capture' },
    ],
    sortFieldMap: {
      fileName: 'fileName',
      normalizedPath: 'normalizedPath',
      linesPct: 'linesPct',
      functionsPct: 'functionsPct',
      branchesPct: 'branchesPct',
      statementsPct: 'statementsPct',
      latestCapturedAt: 'capturedAt',
    },
    statusOptions: [],
  });
